import { useQuery } from 'react-query';
import { queryKey } from 'constants/queryKey';
import { ApiClientError } from 'api/client';
import Logger from 'utils/logger';
import { InstagramAudioApi } from '../api/instagramAudio';
import type { InstagramAudioTrack } from '../types';

type Params = {
  postId: number;
  token: string;
  enabled?: boolean;
};

/**
 * The share link has no session, so the track comes from the public preview
 * API, which looks the audio up from the post itself.
 */
export function useInstagramAudioPublicTrackQuery({
  postId,
  token,
  enabled = true,
}: Params) {
  return useQuery<InstagramAudioTrack, ApiClientError>(
    queryKey.instagramAudioPublicTrack({ postId, token }),
    () => InstagramAudioApi.publicDetail({ postId, token }),
    {
      enabled,
      staleTime: 0,
      cacheTime: 5 * 60 * 1000,
      retry: false,
      onError: (apiError) => Logger.error(apiError),
    },
  );
}
